
import Vue from 'vue';
import { mapState } from 'vuex';
import { makeUrl } from '~/components/utils/browser/url';

export default Vue.extend({
  name: 'PublicPortfolioEmailSignature',
  computed: {
    ...mapState('portfolio', ['user', 'contacts']),
    link(): string {
      return makeUrl(`/p/${this.$auth.user!.slug}`);
    },
  },
});
